import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedNumber } from 'react-intl'
import { T } from 'components/components/i18n'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, FormControl, OverlayTrigger, Popover } from 'react-bootstrap'
import Button from '../../../../Button'
import { addItem } from '../../../../../../actions/cart'
import { setRim } from '../../../../../../actions/wheelBuilder'
import styles from './styles.less'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck, faEdit, faShoppingCart, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { calculatePrice } from '../../../../../../helpers/price'
import ProductInfoPopover from '../../ProductInfoPopover/v2'
import SupplierPopover from '../../SupplierPopover'
import ConditionPopover from '../../ConditionPopover'
import StockAmountMessage from '../../StockAmountMessage'
import DeliveryTime from '../../../../DeliveryTime'
import RimTypeLabel from '../../RimTypeLabel'
import CommentInput from 'components/components/Form/CommentInput'
import { pathTranslate } from 'helpers/routing'
import { getUnit } from 'helpers/order'
import Unit from 'components/components/Cart/Unit'

export class RimProduct extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      count: this.props.initialCount,
      comment: ''
    }
  }

  onButtonClick() {
    const { product, shop, cartItems, isWheelBuilder, addToCart, setRim } = this.props
    if (!isWheelBuilder)
      addToCart(product.id, this.state.count, shop, cartItems, this.state.comment)
    else
      setRim(product, this.state.count, this.state.comment)
  }

  onCountChange(event) {
    this.setState({
      count: parseInt(event.target.value, 10)
    })
  }

  onCommentChange(event) {
    this.setState({
      comment: event.target.value
    })
  }

  render() {
    const {
      product,
      shop,
      includeVat,
      category,
      isWheelBuilder,
      cartItems,
      selectedNumberOfPcs,
      priceType,
      currency,
      rimWheelLoad,
      isVehicle,
      inProgress,
      overrideUnit,
      unitTooltip,
    } = this.props
    const _productLinkUrl = isWheelBuilder ? `/hjul/${category.slug}/${product.id}/${product.slug}` : `/${category.slug}/${product.id}/${product.slug}`
    const productLinkUrl = shop.locale === 'nb' ? pathTranslate(_productLinkUrl) : _productLinkUrl
    const imageSrc = product.image && product.image.webshop_thumb ? product.image.webshop_thumb : '/images/default-product-thumbnail.png'

    let productDescription
    if (shop.showFullProductDescriptionOnSearch)
      productDescription = product.description

    let stockAmount

    if (!!shop.showStockAmountsOnSearch) {
      stockAmount = <StockAmountMessage stock={product.stock} showActualStockAmounts={shop.showActualStockAmounts} />
    }

    let priceValue
    if (priceType === 'consumer')
      priceValue = product.consumerPrice
    else
      priceValue = product.price
    const vatPercent = includeVat ? product.vatPercent : null
    priceValue = calculatePrice(priceValue, selectedNumberOfPcs, vatPercent)
    const price = (
      <FormattedNumber
        style={`currency`}
        value={priceValue}
        currency={currency}
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      />
    )

    let supplier
    if (!!shop.showSupplierInSearchResults) {
      const productSource = product.supplier.id ? product.supplier : product.location
      if (!productSource.hideIt)
        supplier = <SupplierPopover supplier={product.supplier} supplierNameComponent={productSource.name} />
    }

    let delivery, deliveryClass
    switch(product.estimatedDeliveryType) {
      case 0:
      case 5:
        deliveryClass = 'text-danger font-weight-bold'
        break
      case 1:
        deliveryClass = 'text-success font-weight-bold'
        break
      case 2:
        deliveryClass = 'text-info font-weight-bold'
        break
      case 3:
        deliveryClass = 'text-warning font-weight-bold'
        break
      default:
        deliveryClass = ''
    }

    if(product.deliveryTime && !product.deliveryTime.hideIt) {
      if (shop.deliveryDisplayMode === 1 ) {
        let deliveryTime
        deliveryTime = <DeliveryTime deliveryInfo={product.deliveryTime} />
        delivery = <span className={deliveryClass}>{deliveryTime}</span>
      } else {
        delivery = (
          <FontAwesomeIcon
            className={deliveryClass}
            icon={faTruck}
          />
        )
      }
    }

    // const accentedCellClass = `${styles.accentedCell} background-light`
    const itemsAlreadyInCart = cartItems.filter(item => item.id === product.id)
    let quantityInCartMessage
    const sum = itemsAlreadyInCart.reduce((sum, item) => (sum + item.count), 0);
    if (sum > 0)
      quantityInCartMessage = <Link to="/kassa">
        {sum}
        <T id="pcs already in cart"/>
      </Link>
    let button
    if (!shop.prohibitPurchase)
      button = (
        <Button
          className={`${styles.button} productList_buyButton`}
          onClick={this.onButtonClick.bind(this)}
          icon={<FontAwesomeIcon icon={faShoppingCart} />}
          label={<T id="Buy" />}
          inProgress={inProgress}
        />
      )

    const productTitle = [
      <div className={styles.productTitleWrapper}>
        <Link
          to={productLinkUrl}
          className={`${styles.productTitle} text-colored`}
          key={`product-name_${product.id}`}
          title={`${product.brand && product.brand.name} ${product.model && product.model.name}`}
        >
          <span>
            <span>{product.brand && product.brand.name}</span>
          </span>
          <span>
            <em>{product.model && product.model.name}</em>
          </span>
        </Link>
        <div className={styles.productDimensions} key="product-description">
          {product.attrs && product.attrs.dimension}
        </div>
      </div>
    ]

    const wheelLoad = product?.attrs?.wheelLoad || 0
    let WheelLoadHtml
    if ((wheelLoad && (wheelLoad > rimWheelLoad)) || !isVehicle) {
      WheelLoadHtml = (
        <span>
          {wheelLoad}
        </span>
      )
    } else {
      const warning = wheelLoad ? styles.orange : styles.red
      const warningText = wheelLoad
        ? <T id="This rim may not be suitable, as its load rating is lower than the required load for your vehicle's axle." />
        : <T id="We currently do not have load rating information for this rim, so we are unable to determine if it is suitable for your vehicle." />
      WheelLoadHtml = (
        <OverlayTrigger
          placement="top"
          overlay={
            <Popover>
              {warningText}
            </Popover>
          }
        >
          <div className={`${styles.wheelLoad} ${warning}`}>
            <span>
              {wheelLoad || '-'}
            </span>
            <FontAwesomeIcon className={styles.carInfoIcon} icon={faInfoCircle} />
          </div>
        </OverlayTrigger>
      )
    }

    return (
      <li className={`${styles.product} rim-product border-colored`}>
        <Link to={productLinkUrl} className={`${styles.flexCenter} ${styles.productThumbnail}`}>
          <img src={imageSrc} alt=""/>
        </Link>

        <div className={styles.productMainDetailsWrapper}>
          <ProductInfoPopover product={product} productTitleElements={productTitle} />
          <div className={`${styles.productProperties} productProperties`}>
            <div>{productDescription}</div>
            <div className={styles.comment}>{product.comment}</div>
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.characteristicsTitle}>Characteristics</div>
          <div className={styles.characteristicsSection}>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Width"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.width || '-'}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Diameter"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.diameter || '-'}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Bolt pattern"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.boltPatterns.join(", ") || '-'}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Et"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.etOffset || '-'}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Hub bore"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.centerBore || '-'}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Wheel load"/>:
              </Col>
              <Col xs={6}>
                {WheelLoadHtml}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Item"/>:
              </Col>
              <Col xs={6}>
                {product.productId}
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Type"/>:
              </Col>
              <Col xs={6}>
                <RimTypeLabel fullName rimType={product.attrs.rimType.id} />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className={styles.propertyTitle}>
                <T id="Color"/>:
              </Col>
              <Col xs={6}>
                {product.attrs.color || '-'}
              </Col>
            </Row>
          </div>
          <div className={styles.characteristicsSection}>
            {stockAmount}
            {delivery}
            {supplier}
            {product.condition && product.condition.type.toUpperCase() !== 'NEW' && (
              <ConditionPopover condition={product.condition} />
            )}
            {quantityInCartMessage}
            {shop.limitPurchaseQuantityToStock && product.stock < parseInt(this.state.count, 10) && (
              <span className={styles.limitedQuantityMessage}>
                <T id="Limited quantity available" />
              </span>
            )}
            {product.bonus !== 0 && (
              <span>
                <FormattedNumber
                  style={`percent`}
                  value={product.bonus/100}
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                />&nbsp;<T id="bonus"/>
              </span>
            )}
          </div>
        </div>

        <div className={styles.cart}>
          <div className={styles.noteWrapper}>
            <FontAwesomeIcon
              icon={faEdit}
            />
            <T id="Add note">
              {
                msg =>  (
                  <CommentInput
                    placeholder={msg}
                    className={`${styles.commentInput}`}
                    onChange={this.onCommentChange.bind(this)}
                  />
                )
              }
            </T>
          </div>

          <div className={`border-colored ${styles.orderInfo} orderInfo`}>
            <div className={styles.orderInfoItem}>
              <div className={styles.priceWrapper}>
                <div className={`${styles.priceInfo} productList_priceInfo`}>
                  <strong className={`${styles.price} productList_price text-colored`}>
                    {price}
                    <span className={`${styles.pricePcs} productList_pricePcs text-normal`}>
                      / {selectedNumberOfPcs === 1 ? '' : selectedNumberOfPcs}
                      <Unit unit={overrideUnit} tooltip={unitTooltip} />
                    </span>
                  </strong>
                </div>
              </div>
              <div className={styles.quantityWrapper}>
                <span className={styles.label}><T id="Items"/></span>
                <span className={styles.input}>
                  <FormControl
                    type="number"
                    className={styles.commentInput}
                    name="count"
                    value={this.state.count}
                    onChange={this.onCountChange.bind(this)}
                    min="1"
                    max="99"
                  />
                </span>
              </div>
            </div>
          </div>

          <div className={styles.buttonWrapper}>
            {button}
          </div>
        </div>
      </li>
    )
  }
}

const mapStateToProps = (state, props) => {
  const overrideInitialCount = state.shop.topBrandsConfig?.['quantity']?.['rim']?.initial
  const overrideUnit = state.shop.topBrandsConfig?.['quantity']?.['rim']
    ? getUnit(
        {
          ...state.shop.topBrandsConfig['quantity']['rim'],
          description: props?.product?.description
        },
        state.shop.quantityConfig.rim.unit
      )
    : state.shop.quantityConfig.rim.unit
  const maxCount = overrideInitialCount
    ? parseInt(overrideInitialCount, 10) : 4;
  return {
    includeVat: state.price.includeVat,
    selectedNumberOfPcs: state.price.selectedNumberOfPcs,
    priceType: state.price.priceType,
    shop: state.shop,
    cartItems: state.cart.items,
    category: state.categories.activeCategory,
    isWheelBuilder: state.wheelBuilder.showWheelProgress,
    currency: state.intl.currency,
    inProgress: state.cart.updateInProgress[props.product.id],
    isVehicle: state?.vehicle?.vehicle?.vehicleId,
    rimWheelLoad: state?.vehicle?.vehicle?.rimWheelLoad,
    overrideUnit,
    unitTooltip: state.shop.quantityConfig.rim.tooltip,
    initialCount: state.shop.limitPurchaseQuantityToStock
      ? Math.min(props.product.stock, maxCount) : maxCount,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  addToCart: (itemId, count, shop, cartItems, comment) => addItem(itemId, count, shop, cartItems, comment),
  setRim: (product, count, comment) => setRim(product, count, comment)
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RimProduct)
